export default [
  {
    sectionTitle: 'Sites',
    ids: [[2, 5], [6, 11]]
  },
  {
    sectionTitle: 'Daily',
    ids: [4, 15]
  },
  {
    sectionTitle: 'Weekly',
    ids: [8, 7, 9, 48, 10, 70, 19, 24, 40, 22, 12, 18, 21, 17, 16]
  },
  {
    sectionTitle: 'Promotions',
    ids: [25, 31]
  }
];



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters/newsletters_page/newsletters_page_data.js